module.exports = __webpack_public_path__ + "static/media/lybra.76610604.svg";